import { createMemo } from "solid-js";
import { calcPromoPrice } from "../../googleScripts/sheet/lib/promo";
import "./Price.scss";

export function Price(props: {
  price: number;
  promoString?: string;
  forceDecimals?: boolean;
}) {
  const price = () => props.price;
  const promoString = () => props.promoString;

  const decimals = () =>
    props.forceDecimals || price().toString().split(".")[1]?.length ? 2 : 0;

  const promoPrice = createMemo(() => calcPromoPrice(price(), promoString()));

  return (
    <div class={"price " + (promoPrice() ? "price__promo" : "")}>
      <span class="price_standard">
        <span class="price_value">{price().toFixed(decimals())}</span>
        <span class="price_unit">€</span> 
      </span>
      {promoPrice() && (
      <span class="price_promo">
        <span class="price_value">{promoPrice()!.toFixed(decimals())}</span>
        <span class="price_unit">€</span> 
      </span>
      )}
    </div>
  );
}

